module.exports = __webpack_public_path__ + "assets/img/myGift.0c14e384.png";